<template>
  <div class="index-service-box" ref="doc_index">
    <!-- 吸顶组件 start-->
    <!--<div class="search-box search-box-fixed" v-show="is_search_scikty">
      <div class="search-img"></div>
      <input type="text" placeholder="搜医生、疾病" @click="routePush('/search')" />
      <div class="kefu-img" @click="handleCall"></div>
    </div>
    <div class="doc-filter doc-filter-fixed" v-if="is_filter_scikty">
      <div
        class="display_flex_start"
        :class="{'active':filter_index == item.key}"
        v-for="(item,index) in filter_list"
        @click="handleFilter(item.key,1,index)"
        :key="index"
      >
        {{item.name}}
        <img
          class="filter-img"
          :src="filter_index == item.key?filter_img1:filter_img0"
        />
      </div>
    </div>-->
    <!-- 吸顶组件 end-->
    <div class="index-bg">

    </div>
    <div class="index-content">
      <div class="index-menu">
        <div class="index-search" @click="$router.push('/search')">
          <i class="icon icon-index-search"></i>
          <span>输入医生、疾病搜索</span>
        </div>
        <h3 class="search-h3">按疾病找医生<span>公立三甲医院知名肿瘤专家</span></h3>


        <div class="index-menus">
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30863')">
            <i class="icon icon-index-menu icon-index-fei"></i>
            <p>肺肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30865')">
            <i class="icon icon-index-menu icon-index-wei"></i>
            <p>胃肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30866')">
            <i class="icon icon-index-menu icon-index-jie"></i>
            <p>结直肠肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30868')">
            <i class="icon icon-index-menu icon-index-shi"></i>
            <p>食管肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30867')">
            <i class="icon icon-index-menu icon-index-gan"></i>
            <p>肝肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30872')">
            <i class="icon icon-index-menu icon-index-yi"></i>
            <p>胰腺癌</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30869')">
            <i class="icon icon-index-menu icon-index-jia"></i>
            <p>甲状腺肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30871')">
            <i class="icon icon-index-menu icon-index-nao"></i>
            <p>脑部肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30875')">
            <i class="icon icon-index-menu icon-index-lin"></i>
            <p>淋巴肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30874')">
            <i class="icon icon-index-menu icon-index-fu"></i>
            <p>妇科肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30873')">
            <i class="icon icon-index-menu icon-index-qian"></i>
            <p>前列腺肿瘤</p>
          </div>
          <div class="index-menu-item" @click="$router.push('/find_doctor?disid=30878')">
            <i class="icon icon-index-menu icon-index-more"></i>
            <p>其他肿瘤</p>
          </div>
        </div>
      </div>

      <div class="zhuanjia">
        <h3 class="zhuanjia-h3" @click="$router.push('/find_doctor')">推荐专家</h3>

        <div class="zhuanjia-card" v-for="(item,index) in doclist">
          <div class="zhuanjia-card-info" @click="$router.push('/doctor_main?doctorid='+item.id)">
            <div class="zhuanjia-text">
              <h3>{{item.zname}}</h3>
              <p>{{item.position}}</p>
              <p>{{item.hospname}}</p>
              <div class="zhuanjia-tags">
                <span v-for="(items,index) in item.label_list" v-if="index<3">{{items}}</span>
              </div>
            </div>
            <div class="zhuanjia-img">
              <img :src="item.cover_image" alt="">
            </div>
            <div class="my-zhuanjia" v-if="item.type == 3">我的医生</div>
          </div>
          <div class="zhuanjia-goodbe" @click="$router.push('/doctor_main?doctorid='+item.id)">
            擅长:{{item.goodable}}
          </div>
          <div class="servies-box">
            <div class="servies-item ser-tuwen" :class="{'is_close':item.is_graphic == 1}" @click="item.is_graphic == 0?$router.push('/wenzhen_order_pay?type=1&doctorid='+item.id):$toast.center('图文问诊暂未开通')">
              <p>图文问诊</p>
              <span v-if="item.is_graphic == 0">￥{{item.graphic_money/100}}</span>
              <span v-else>未开通</span>
            </div>
            <div class="servies-item ser-dianhua" :class="{'is_close':item.is_phone == 1}" @click="item.is_phone==0?$router.push('/wenzhen_order_pay?type=2&doctorid='+item.id):$toast.center('电话问诊暂未开通')">
              <p>电话问诊</p>
              <span v-if="item.is_phone == 0">￥{{item.phone_money/100}}</span>
              <span v-else>未开通</span>
            </div>
            <div class="servies-item ser-shipin is_close" @click="$toast.center('视频问诊暂未开通')">
              <p>视频问诊</p>
              <span>未开通</span>
            </div>
            <!--<div class="servies-item ser-shipin" :class="{'is_close':item.is_video == 1}" @click="item.is_video==0?$router.push('/shipin_order_pay?&doctorid='+item.id):$toast.center('视频问诊暂未开通')">
              <p>视频问诊</p>
              <span v-if="item.is_video == 0">￥{{item.video_money/100}}</span>
              <span v-else>未开通</span>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <tabbar />
  </div>
</template>

<script>
import http from "../../request/http";
import tabbar from "../../components/tabbar/tabbar";
import loadMore from "../loadMore";
import {getCustomerPhone} from '../../utils/index'
export default {
  name: "doctor_list",
  data() {
    return {
      doclist:[]
    }
  },
  components: {
    tabbar,
  },
  mounted() {
    this.hotdoc
  },
  computed: {
    hotdoc(){
      http.post('/api/wap/doctor/hot').then(res=>{
        console.log(res)
        res.data.forEach(e=>{
          if (e.label) {
            e.label_list = e.label.split(",");
          }
        })
        this.doclist = res.data
      })
    }
  }
};
</script>

<style scoped>
@import "./index.css";
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue